var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 542 382",
    style: {
      enableBackground: "new 0 0 542 382"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F93D66;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.1,282.2l144.3-86.6c3.5-2.1,3.5-7.1,0-9.1L215.1,99.8c-3.6-2.1-8.1,0.4-8.1,4.6v173.2 C207,281.7,211.5,284.3,215.1,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,382c-62.8,0-143.3-1-175.6-2.9h-0.1c-35-2.4-54.7-8.8-71.7-38.7C7.3,312.4,0,266.3,0,191.2V191 C0,115.8,7.3,69.7,23.6,41.5C40.6,11.5,61.2,5,95.4,3C128,0.8,207.5,0,271.1,0s143,0.8,175.5,3c34.3,1.9,54.8,8.4,71.7,38.5 c16.4,28.1,23.8,74.2,23.8,149.5v0.3c0,75.3-7.3,121.3-23.7,149.2c-16.9,30-36.6,36.4-71.6,38.7h-0.2C414,381,333.6,382,271.1,382z  M97.3,349.2c31.8,1.9,111.4,2.8,173.7,2.8c62.1,0,141.6-1,173.6-2.8c29.6-2,37.6-6,47.5-23.6l0.2-0.3 C505.8,302.6,512,260,512,191.2V191c0-68.9-6.3-111.6-19.7-134.5l-0.1-0.2c-10-17.8-18-21.7-47.4-23.4h-0.2 C412.9,30.8,331.3,30,271.1,30s-141.9,0.8-173.7,2.9h-0.1c-29.5,1.7-37.5,5.6-47.6,23.4l-0.1,0.1C36.2,79.6,30,122.3,30,190.9v0.2 c0,68.8,6.2,111.4,19.6,134.2l0.1,0.2C60.3,344.1,69.4,347.3,97.3,349.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ec887a72a81a3e47d4a948af6371bacb.svg";
export { ForwardRef as ReactComponent };